<template>
  <div class="river-index">
    <navigation customClickEvent @click="goBack">优选借款</navigation>
    <pulldown-page
      :refresh="onRefresh"
      :is-scroll="true"
      class="home"
      background="#FAFAFA"
      color="#333333"
    >
      <van-swipe
        v-if="bannerList.length > 0"
        :autoplay="3000"
        :duration="500"
        class="banner"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="jumpOutLink(item)"
        >
          <img :src="item.bannerUrl" :alt="item.content" >
        </van-swipe-item>
        <div
          v-if="bannerList.length > 1"
          slot="indicator"
          class="indicator"
        >
          <div
            v-for="(item, index) in bannerList"
            :key="index"
            class="indicator-item"
          />
        </div>
      </van-swipe>
      <div class="river" v-if="borrowList&&borrowList.length>0">
        <div class="borrow">
          <main >
            <p class="title">精彩推荐</p>
            <div v-for="(item,index) in borrowList" :key="index" class="item" @click="borrowMoney(item)">
              <div class="top">
                <div class="top-left">
                  <img :src="item.icon">
                  <span class="top-left-more">{{item.productName}}</span>
                  <div class="top-left-border" v-for="(item,index) in dealWorld(item.cornerWord)" :key="index">{{item}}</div>
                </div>
                <div class="top-right"><span class="red">{{item.loanCounts}}</span>人已借款</div>
              </div>
              <div class="bottom">
                <div class="bottom-left">
                  <div class="bottom-left-limit">额度高达 (元) </div>
                  <div class="flex-center">
                    <div class="bottom-left-money">{{ item.configLimit|currency }}</div>
                    <div class="bottom-right">{{item.buttonName}}</div>
                  </div>
                  <div class="bottom-left-label">
                    <span>年化利率 {{item.minPrice}}%-{{item.maxPrice}}%,</span>
                    <span>期限{{item.minTerms}}-{{item.terms}}个月</span>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <footer>- 没有更多了，试试上面的产品吧 -</footer>
      </div>
      <div v-else-if="borrowList" class="none">
        <img src="./images/icon_yihan@2x.png" class="none-img"/>
        <div class="none-title">很遗憾，暂时没有符合您的产品</div>
        <div class="none-next">下次再来逛逛吧～</div>
      </div>
    </pulldown-page>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { mapActions } from 'vuex'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { judgeClientSystem, getKey } from '../../../assets/utils'
export default {
  name: 'river-diversion',
  customReadyNotify: true,
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  data () {
    return {
      borrowList: null, // 借款列表
      bannerList: [{
        bannerUrl: require('../images/img_1@2x.png'),
        content: '天美贷'
      }] // banner展示
    }
  },
  async created () {
    try {
      await this.getUserInfoX({
        forceUpdate: true
      })
      await this.init()
      this.$bus.$emit('ready')
    } catch (e) {
      this.$bus.$emit('error')
    }
  },
  methods: {
    ...mapActions('user', ['getBorrowList', 'getUserStatus', 'getUserInfoX']),
    ...mapActions(['dataPoint']),
    // 处理标签
    dealWorld (cornerWord = '') {
      if (cornerWord) {
        return cornerWord.split(',')
      } else {
        return []
      }
    },
    // 初始化
    async init () {
      const response = await this.getBorrowList({ showPlace: 'ALL', queryBanner: true, version: 'V2' })
      if (response.success) {
        const { configs } = response.data
        this.borrowList = configs || []
        this.borrowList.map(item => {
          this.$report({
            id: 10002,
            args: { screen: 'river_diversion_detail2', position: 'river_diversion_detail2', target: item.configId }
          })
        })
      }
    },
    // 下拉刷新
    onRefresh () {
      this.init()
    },
    // banner跳转
    jumpOutLink () {
      this.$report({
        id: 10295
      })
      this.dataPoint({
        id: 10295
      })
      const { authStatus } = getKey('userInfo') || {}
      if (!authStatus.includes('OCR')) {
        return this.$router.replace('/authentication/id')
      }
      if (!authStatus.includes('INFO')) {
        return this.$router.replace('/authentication/base')
      }
    },
    // 去借款
    borrowMoney (item = {}) {
      const { configId } = item
      this.$report({
        id: 10294,
        args: {
          screen: 'river_diversion_detail2', target: configId
        }
      })
      this.dataPoint(
        {
          id: 10294, screen: 'river_diversion_detail2', target: configId
        }
      )// 同步埋点
      this.jumpMiddle(item)
    },
    // 跳转中间界面
    jumpMiddle (item) {
      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$router.push({ path: '/river/middle', query: { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode, ...sourceData, version: 'v2' } })
    },
    // 确认返回
    goBack () {
      const { source } = this.$route.query || {}
      if (hasNativeMethod('navigateTo') && !source && judgeClientSystem() !== 'IOS') {
        return jsBridge('exit')
      } else {
        let pathname = decodeURIComponent(source).pathname || '/'
        this.$router.push(pathname)
      }
    }
  }
}
</script>
<style>
.page{
  width: 750px;
  height: 100%;
  /* overflow: scroll; */
}
</style>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.river-index{
  width: 750px;
  height: 100%;
  background: white;
  overflow: scroll;
  .banner {
      width: 690px;
      height: 250px;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      border-radius:20px;
      .van-swipe-item {
          width: 690px;
          height: 250px;
      }
      img {
          width: 100%;
          height: 100%;
      }

      .indicator {
          position: absolute;
          bottom: 16px;
          display: flex;
          flex-direction: row;
          left: 50%;
          transform: translateX(-50%);

          .indicator-item {
              width: 16px;
              height: 4px;
              background-color: #fff;
              opacity: 0.5;
              border-radius: 2px;

              & + .indicator-item {
                  margin-left: 14px;
              }

              &.active {
                  opacity: 1;
              }
          }
      }
  }
  .river{
    overflow: auto;
  }
  .borrow{
    width: 690px;
    background: #EBF0F9;
    border-radius: 20px;
    padding:50px 0 50px;
    margin:30px auto 0;
    overflow: auto;
    main{
      .title{
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        padding-left:40px;
      }
      .item{
        width: 630px;
        background: #FFFFFF;
        border-radius: 10px;
        margin:20px auto 0;
        padding:0 30px;
        .top{
          height:110px;
          border-bottom:1px solid #EEE;
          display: flex;
          align-items:center;
          justify-content:space-between;
          &-left{
            display: flex;
            justify-content:space-between;
            align-items:center;
            &-more{
              margin-left:14px;
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              max-width:250px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            >img{
            width:48px;
            height:48px;
            border-radius: 10px;
            }
            &-border{
              margin-left:10px;
              margin-right:5px;
              max-width: 200px;
              line-height: 34px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid #FF4633;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FF4633;
              padding:0 5px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
          &-right{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
          .red{
            color:red;
          }
        }
        .bottom{
          // display: flex;
          // justify-content: space-between;
          // align-items:center;
          // height: 210px;
          padding:39px 0;
          &-left{
            display: flex;
            flex-direction:column;
            align-items:space-between;
            justify-content: center;
            // height: 85px;
            // width:400px;
            &-limit{
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
            &-money{
              font-size: 40px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
              color: #333333;
            }
            &-label{
              // width: 288px;
              padding-top:17px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .flex-center{
              display: flex;
              justify-content:space-between;
              align-items: center;
              .bottom-right{
                width: 170px;
                height: 60px;
                line-height: 60px;
                text-align:center;
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                border-radius: 30px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                height:60px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
  .none{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top:140px;
        // min-height:800px;
        &-img{
          width:140px;
          height:140px;
          display:block;
        }
        &-title{
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top:40px;
        }
        &-next{
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-top:9px;
        }
      }
  footer{
    padding:50px 0 75px;
    text-align:center;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .logout-dialog {
      padding: 60px 0 39px;
      font-family: PingFangSC-Regular,PingFang SC;
      .tong-guo{
        text-align:center;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      main{
        padding:0 0 0 90px;
        font-family: PingFangSC-Medium, PingFang SC;
        .middle{
        display:flex;
        align-items:center;
        margin:84px 0 0 0;
        &-img{
            width: 48px;
            height: 48px;
            border-radius:10px;
        }
        &-productName{
            max-width:300px;
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            margin-left:12px;
            overflow: hidden;//溢出隐藏
            white-space: nowrap;//禁止换行
            text-overflow: ellipsis;//...
        }
        &-cornerWord{
            padding:4px 10px;
            border-radius: 4px;
            border: 1px solid #FF4633;
            line-height:34px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #FF4633;
            margin-left:15px;
        }
      }
      .e-du-gao-da{
          height: 92px;
          font-size: 66px;
          font-weight: 500;
          color: #333333;
          line-height: 92px;
          margin-top:19px;
          width: 410px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
      }
      .nian-hua-li-lv{
          height: 33px;
          font-size: 24px;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
      }
      .red{
          color:#FF4633;
      }
      } 
      .give-up{
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        margin-top:38px;
        text-align:center;
      }
      .seize{
        width: 440px;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align:center;
        margin:69px auto 0;
        line-height: 80px;
      }
  }
}
</style>
